/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_Before_LabelInputs */

const da_forside_redact_before_label = /** @type {(inputs: Forside_Redact_Before_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På din computer`)
};

/** @type {(inputs: Forside_Redact_Before_LabelInputs) => LocalizedString} */
const en_forside_redact_before_label = da_forside_redact_before_label;

/**

* @param {Forside_Redact_Before_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_before_label = /** @type {((inputs?: Forside_Redact_Before_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_Before_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_before_label(inputs)
	return /** @type {LocalizedString} */ ("På din computer")
});